import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/app/Layout";
import Home from "@/pages/Home";
import FaqResidents from "@/pages/FaqResidents";
import FaqLeaseholders from "@/pages/FaqLeaseholders";
import NewsList from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import History from "@/pages/History";
import Contact from "@/pages/Contact";
import Rta from "@/pages/Rta";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function AdminGuard({ children }) {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App paper-bg">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <AdminGuard>
                  <AdminDashboard />
                </AdminGuard>
              }
            />
            <Route
              path="/*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/faq/residents" element={<FaqResidents />} />
                    <Route path="/faq/leaseholders" element={<FaqLeaseholders />} />
                    <Route path="/news" element={<NewsList />} />
                    <Route path="/news/:id" element={<NewsDetail />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/projects/:id" element={<ProjectDetail />} />
                    <Route path="/history" element={<History />} />
                    <Route path="/rta" element={<Rta />} />
                    <Route path="/contact" element={<Contact />} />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
